import { all, } from 'redux-saga/effects'

/**
 * Module initializer
 * @param {Array} of Models
 * @param {Object} extra configs
 * @return {Object} actions/reducers/sagas generators
 */
export default (models, config={ activeSaga: true, }) => {
  const actions = {}
  const types   = {}
  const reducers= {}
  const effects = {}
  let sagas   = []

  models.map(model => {
    let key = model.name
    actions[key] = model.actionCreators
    reducers[key] = model.reducer
    types[key] = model.actionsTypes
    effects[key] = model.effects
    sagas = sagas.concat(model.sagas)
  })

  // Run all the watchers
  let rootSagas = function* root() {
    yield all(sagas)
  }

  return {
    actions,
    types,
    reducers,
    rootSagas,
    sagas,
  }
}



// WEBPACK FOOTER //
// ./src/init.js